import { TRegionDashboardStoreState } from './types';

export function getIndicatorCards(state: TRegionDashboardStoreState) {
  return state.indicatorCards;
}

export function getPersonInfo(state: TRegionDashboardStoreState) {
  return state.personInfo;
}

export function getTopRfSubjectsEvents(state: TRegionDashboardStoreState) {
  return state.topRfSubjectsEvents;
}

export function getTopRfSubjectsGrowthRate(state: TRegionDashboardStoreState) {
  return state.topRfSubjectsGrowthRate;
}

export function getEventsCountByTypes(state: TRegionDashboardStoreState) {
  return state.eventsCountByTypes;
}

export function getAgreementsCountByTypes(state: TRegionDashboardStoreState) {
  return state.agreementsCountByTypes;
}
